import { convertLabelMapToConfig, convertLabelUomMapToConfig, mergeConfig } from '../../../Core/Helpers/configHelpers';

const getLabelConfig = (prefix: string) =>
  mergeConfig(
    convertLabelMapToConfig({
      [`${prefix}.Preparation.MeasurementApplication`]: 'Measurement Application',
      [`${prefix}.Preparation.TestNumber`]: 'Test Number',
      [`${prefix}.IsParticleDensityAssumed`]: 'Particle Density Determination',
      [`${prefix}.ParticleDensityAssumed`]: 'Assumed Particle Density',

      [`${prefix}.ReferenceDensity.ImportedTest`]: 'Reference Density',

      [`${prefix}.ReferenceDensityResults.ParticleDensity`]: 'Reference Particle Density',

      [`${prefix}.Results.MaximumDryDensity`]: 'Maximum Dry Density',
      [`${prefix}.Results.OptimumMoistureContent`]: 'Optimum Moisture Content',
      [`${prefix}.Results.RelativeCompaction`]: 'Relative Compaction',
      [`${prefix}.Results.AirVoids`]: 'Air Voids',
      [`${prefix}.Results.ReportResultsOption`]: 'Reported Results',
    }),
    convertLabelUomMapToConfig({
      [`${prefix}.Results.OptimumMoistureContent`]: '%',
      [`${prefix}.Results.RelativeCompaction`]: '%',
      [`${prefix}.Results.AirVoids`]: '%',
    })
  );

export default getLabelConfig;
